import Request from "../../shared/utils/_request";

class Hunterorder {
  constructor() {}
  //客户管理列表接口
  getList(payload) {
    return Request.post("head-post/post/search", payload);
  }

  getHrSearch(payload) {
    return Request.post("account/suggest", payload);
  }

  //拉去当前点击条信息的详情接口
  getLatest(payload) {
    return Request.post("post/feed-back/getLatest", payload);
  }

  //拉取不感兴趣原因接口
  getNotInterest(payload) {
    return Request.post("post/NotInterestedReason/get-all", payload);
  }

  //添加没兴趣保存接口
  addNoInterest(payload) {
    return Request.post("post/feed-back/create", payload);
  }

  //编辑没兴趣保存接口
  editNoInterest(payload) {
    return Request.post("post/feed-back/update", payload);
  }
}

export const hunterorder = new Hunterorder();
